import styled from 'styled-components';
import { colors } from '../styles/variables';

const CartCheckoutView = styled.div`
  & > div {
    padding: 16px 8px;
    border: 1px solid ${colors.gray300};
    border-bottom: 0;
  }
  & > div:last-of-type {
    border-bottom: 1px solid ${colors.gray300};
  }
  & > .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid ${colors.gray300};
    background-color: ${colors.white};
  }
  & > .note {
    font-size: 0.8em;
    color: ${colors.gray600};
    margin: 0.5em 0;
  }
`;

export default CartCheckoutView;
